import { AppState } from "@Store/index";
import { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  fetchBookFormPageDataIfNeeded,
  shouldFetchBookForm,
  updateInitialFormState,
  updateLeadData,
} from "./data/bookFormReducer";
import axios from "axios";
import config from "@Config/index";
import useIsApp from "hooks/useIsApp";

const useBookFormPage = (props: any) => {
  const dispatch = useDispatch();
  const isApp = useIsApp();
  const [leadData, setLeadData] = useState(null);
  const { isError, isLoading, showFullPageLoader } = useSelector(
    ({ bookFormData }: AppState) => ({
      isError: bookFormData.readyStatus === "failure",
      isLoading:
        bookFormData.readyStatus === "request" ||
        shouldFetchBookForm(bookFormData, props?.match?.params?.id),
      showFullPageLoader:
        !bookFormData.data || bookFormData?.data?.canonical_name !== props?.match?.params?.id,
    }),
    shallowEqual,
  );

  const fetchLead = async (leadUUID: string) => {
    const params = {
      cache: false,
      methods: "inventory_root",
    };
    try {
      const lead = await axios.get(`${config.API_URL}/api/v0/leads/${leadUUID}`, {
        params,
      });
      dispatch(updateLeadData(lead?.data?.data));
      setLeadData(lead?.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(
    () => {
      const queryParams = new URLSearchParams(props?.location.search);
      const initialFromState: any = {};
      for (const [key, value] of queryParams.entries()) {
        initialFromState[key] = value;
      }
      let lead_uuid = "";
      if (queryParams.get("lead_uuid")) {
        lead_uuid = queryParams.get("lead_uuid") || "";
      }
      if (lead_uuid) fetchLead(lead_uuid);
      dispatch(updateInitialFormState({ initialFromState }));
      dispatch(fetchBookFormPageDataIfNeeded(props));
    },
    isApp ? [props?.match?.params?.id, props?.location.search] : [],
  );

  return {
    isError,
    isLoading,
    showFullPageLoader,
    leadData,
  };
};

export default useBookFormPage;
